import React, { useEffect, useState } from 'react';
import { Alert, Button, Form, Spinner } from 'react-bootstrap';
import { platformAPI } from '../../../services/platformAPI';

const WorkPackageSettings = () => {
  const [policy, setPolicy] = useState(null);
  const [candidates, setCandidates] = useState([]);
  const [message, setMessage] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    platformAPI.getWorkPackagePolicy().then((response) => {
      const data = response.data?.data || {};
      setPolicy(data.policy || null);
      setCandidates(data.candidates || []);
    }).catch((error) => {
      setMessage(error?.response?.data?.message || 'Work-package defaults could not be loaded.');
    });
  }, []);

  if (!policy) return message ? <Alert variant="warning">{message}</Alert> : <Spinner size="sm" animation="border" />;

  const update = (code, patch) => {
    setPolicy((current) => ({
      ...current,
      packages: current.packages.map((row) => (row.code === code ? { ...row, ...patch } : row))
    }));
  };

  const save = async () => {
    setSaving(true);
    setMessage('');
    try {
      const response = await platformAPI.saveWorkPackagePolicy({
        packages: policy.packages.map((row) => ({
          ...row,
          ownerUserId: row.ownerUserId || null,
          reviewerUserId: row.reviewerUserId || null
        })),
        managementRecipientIds: policy.managementRecipientIds || []
      });
      setPolicy(response.data?.data?.policy || policy);
      setMessage('Work-package defaults saved. A package with no valid owner stays as Assignment required.');
    } catch (error) {
      setMessage(error?.response?.data?.message || 'These defaults could not be saved.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="mt-4">
      <h2 className="h5">Work packages</h2>
      <p className="small text-muted">
        Company defaults for the four packages created after an authorised Go. Dates use calendar days.
        Working-day scheduling is pending. Email is not sent from this screen.
      </p>
      {message ? <Alert variant="light">{message}</Alert> : null}
      {policy.packages.map((row) => {
        const people = candidates.filter((person) => (person.packages || []).includes(row.code));
        return (
          <div key={row.code} className="border rounded-0 p-2 mb-2 bg-white">
            <strong className="text-capitalize">{row.code.replace('_', ' / ')}</strong>
            <div className="d-flex flex-wrap gap-2 mt-2">
              <Form.Group>
                <Form.Label>Responsible team</Form.Label>
                <Form.Control value={row.teamName || ''} onChange={(event) => update(row.code, { teamName: event.target.value })} />
              </Form.Group>
              <Form.Group>
                <Form.Label>Lead time (calendar days)</Form.Label>
                <Form.Control type="number" min="0" value={row.leadTimeDays} onChange={(event) => update(row.code, { leadTimeDays: Number(event.target.value) })} />
              </Form.Group>
              <Form.Group>
                <Form.Label>Default owner</Form.Label>
                <Form.Select value={row.ownerUserId || ''} onChange={(event) => update(row.code, { ownerUserId: event.target.value })}>
                  <option value="">Assignment required</option>
                  {people.map((person) => <option key={person._id} value={person._id}>{person.name}</option>)}
                </Form.Select>
              </Form.Group>
              <Form.Group>
                <Form.Label>Reviewer</Form.Label>
                <Form.Select value={row.reviewerUserId || ''} onChange={(event) => update(row.code, { reviewerUserId: event.target.value })}>
                  <option value="">None</option>
                  {people.map((person) => <option key={`${person._id}-r`} value={person._id}>{person.name}</option>)}
                </Form.Select>
              </Form.Group>
            </div>
          </div>
        );
      })}
      <Button type="button" size="sm" onClick={save} disabled={saving}>{saving ? 'Saving' : 'Save work-package defaults'}</Button>
    </section>
  );
};

export default WorkPackageSettings;
